import { render, staticRenderFns } from "./StudyVisa.vue?vue&type=template&id=28b5d4d1&"
import script from "./StudyVisa.vue?vue&type=script&lang=js&"
export * from "./StudyVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports